import { render, staticRenderFns } from "./FlexibleOptimizationWidget.vue?vue&type=template&id=4636e1ea&scoped=true&"
import script from "./FlexibleOptimizationWidget.vue?vue&type=script&lang=js&"
export * from "./FlexibleOptimizationWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4636e1ea",
  null
  
)

export default component.exports